/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import {
  Button,
  ButtonWidth,
} from '@practicegenius/pg-ui/src/base/Material/components/Button';
import {Modal} from '../../../components/Modal/Modal';
import {ModalButtons} from '../../../components/Modal/layout';
import {Content, Title} from '../../../shared/utils/sharedStyledElements';

const INVALID_TOKEN_REASONS = Object.freeze({
  INVALID: 'invalid',
  EXPIRED: 'expired',
});

export type InvalidTokenReason =
  (typeof INVALID_TOKEN_REASONS)[keyof typeof INVALID_TOKEN_REASONS];

const titles: {
  [k in InvalidTokenReason]: string;
} = {
  [INVALID_TOKEN_REASONS.INVALID]: 'Password Reset Link Invalid',
  [INVALID_TOKEN_REASONS.EXPIRED]: 'Password Reset Link Expired',
};

const messages: {
  [k in InvalidTokenReason]: string;
} = {
  [INVALID_TOKEN_REASONS.INVALID]:
    'Your password reset link invalid. Please try again with a new link.',
  [INVALID_TOKEN_REASONS.EXPIRED]:
    'Your password reset link expired. Please try again with a new link.',
};

export function InvalidResetTokenModal({
  reason,
  open,
  close,
}: {
  reason: InvalidTokenReason;
  open: boolean;
  close: () => unknown;
}) {
  return (
    <Modal isOpen={open} close={close}>
      <Title>{titles[reason]}</Title>
      <Content>{messages[reason]}</Content>

      <ModalButtons>
        <Button color="secondary" width={ButtonWidth.WIDE} onClick={close}>
          Try Again
        </Button>
      </ModalButtons>
    </Modal>
  );
}
